import {
  Box,
  Typography,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import * as services from "../../services/services";
import { HeaderContext } from "../../App";
import { useEffect, useContext, useState } from "react";
import { Vaccines } from "@mui/icons-material";
const SearchPetPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setTitle, setShowBack } = useContext(HeaderContext);

  useEffect(() => {
    setTitle("ค้นหาสัตว์เลี้ยง");
    setShowBack(true);

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, [setTitle, setShowBack]);

  const scannedPetId = location.state?.scannedPetId || "";
  const [petIdInput, setPetIdInput] = useState(scannedPetId);
  const [pet, setPet] = useState(null);
  const [searched, setSearched] = useState(false);

  const searchPet = async () => {
    if (!petIdInput) return;
    try {
      const res = await services.getPetBowById(petIdInput);
      setPet(res.data || null);
    } catch (err) {
      console.error(err);
      setPet(null);
    }
    setSearched(true);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") searchPet(); // กด Enter ก็ search ได้
  };

  return (
    <Box sx={{ p: 2 }}>
      <TextField
        fullWidth
        placeholder="Bow Pet ID, Microchip"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={searchPet}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
          sx: { borderRadius: "12px" },
        }}
        value={petIdInput}
        onChange={(e) => setPetIdInput(e.target.value)}
        onKeyPress={handleKeyPress}
      />

      <Typography sx={{ mt: 1, color: "gray" }}>
        *ใส่ข้อมูลให้ถูกต้อง จึงจะแสดงผลการค้นหา
      </Typography>

      {/* ผลลัพธ์การค้นหา */}
      {searched && (
        <Box sx={{ mt: 2 }}>
          <Typography
            variant="h6"
            align="center"
            sx={{ mt: 2, fontWeight: 600 }}
          >
            ผลการค้นหา
          </Typography>

          {pet ? (
            <PetCard pet={pet} />
          ) : (
            <Typography align="center"           
             sx={{ mt: 5, fontWeight: 600 }}
            >ไม่พบสัตว์</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
const PetCard = ({ pet }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const params = new URLSearchParams(window.location.search);
    const service_type = params.get('service'); 
    if(service_type == 'vaccine'){
      navigate(`/service/vaccine/${pet.id}`, { state: { pet } });
    }else{
      navigate(`/service/microchip/${pet.id}`, { state: { pet } });
    }
  };
  return (
    <Box
      onClick={handleClick}
      sx={{
        display: "flex",
        p: 2,
        borderRadius: "12px",
        border: "1px solid #ddd",
        mt: 2,
        alignItems: "flex-start",
      }}
    >
      {/* รูป + BowID */}
      <Box sx={{ textAlign: "center", width: 150 }}>
        <Box
          component="img"
          src={pet.image || "https://via.placeholder.com/150"}
          alt="pet"
          sx={{
            width: 120,
            aspectRatio: "1 / 1", // ให้เป็นสี่เหลี่ยมจัตุรัสเสมอ
            borderRadius: "50%", // ทำให้เป็นวงกลม
            objectFit: "cover", // ครอบรูปสวย ไม่บิด ไม่ยืด
            backgroundColor: "#eee", // กันไว้ตอนรูปไม่ขึ้น
          }}
        />

        <Typography sx={{ fontSize: "10px", mt: 1 }}>{pet.id}</Typography>
      </Box>

      {/* ข้อมูลสัตว์ */}
      <Box sx={{ ml: 2 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {pet.name}
        </Typography>

        <Typography sx={{ fontSize: "13px", color: "#777" }}>
          {pet.type} / {pet.breed} /{" "}
          {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[pet.gender] || "-"}
        </Typography>

        {/* <Typography sx={{ fontSize: "13px", mt: 0.5 }}>
        เจ้าของ: <strong>{pet.ownerName}</strong>
      </Typography> */}

        {/* <Typography sx={{ fontSize: "13px" }}>
        HN ID: <strong>{pet.hnId}</strong>
      </Typography> */}

        <Typography sx={{ fontSize: "13px" }}>
          Microchip ID: <strong>{pet.microchip_number}</strong>
        </Typography>
      </Box>
    </Box>
  );
};

export default SearchPetPage;
